module.exports = "<h3>Stored Beats</h3>\n<ul>\n  <li *ngFor=\"let savedBeat of beats | async\">\n    <app-load-saved-beat [childSavedBeat] = \"savedBeat\" (loadSender)=\"loadBeatIntoEditor($event)\"></app-load-saved-beat>\n    {{savedBeat.name}}\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/list-stored-beats/list-stored-beats.component.html
// module id = ../../../../../src/app/list-stored-beats/list-stored-beats.component.html
// module chunks = main